import { useEffect } from 'react'

import { PerformanceInsightsSummaryDatatableQuery } from 'generated/resources/datatable.graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { useGroupBy } from 'modules/performance_analytics/components/GroupByDropdown/GroupByProvider'
import { ChartType } from 'modules/performance_analytics/lib/ChartContext'

import { EmployeePulseInsights } from 'modules/performance_analytics/components/EmployeePulseInsights'
import { Headcount } from 'modules/performance_analytics/components/Headcount'
import { NineBoxGrid } from 'modules/performance_analytics/components/NineBoxGrid'
import { ReviewEmployeeScoreInsights } from 'modules/performance_analytics/components/ReviewEmployeeScoreInsights'

type DashboardFilter = ChartType | 'headcount'
interface Props {
  activeFilter: DashboardFilter
  performanceEnabled: boolean
  showPerformanceEnterpriseUpsellingKit: boolean
}

const Chart = ({
  activeFilter,
  performanceEnabled,
  showPerformanceEnterpriseUpsellingKit = false,
}: Props) => {
  const { groupBy } = useGroupBy()
  const { queryResult } = useDataTable<PerformanceInsightsSummaryDatatableQuery>()
  const totalCount =
    queryResult?.data?.performance?.employeePerformanceInsightsSummariesConnection?.totalCount

  useEffect(() => {
    track(trackingEvents.performanceAnalytics.insightsSummaryOpenAnalyticsDashboard, {
      activeTab: activeFilter === 'line_chart' ? 'performance' : activeFilter,
    })
  }, [activeFilter])

  if (!activeFilter) {
    return
  }

  if (activeFilter === 'headcount') {
    return <Headcount groupBy={groupBy} employeeTotalCount={totalCount} />
  }

  if (activeFilter === '9_box_grid' && performanceEnabled) {
    return <NineBoxGrid />
  }
  if (activeFilter === 'line_chart' && performanceEnabled) {
    return (
      <ReviewEmployeeScoreInsights
        employeeTotalCount={totalCount}
        groupBy={groupBy}
        showEnterpriseUpsellingKit={showPerformanceEnterpriseUpsellingKit}
      />
    )
  }

  if (activeFilter === 'employee_pulse') {
    return <EmployeePulseInsights employeeTotalCount={totalCount} groupBy={groupBy} />
  }
}

export default Chart
